import { createContext } from "react";
import type { User } from "@/types";

export interface AuthContextType {
  user: User | null;
  token: string | null;
  isLoading: boolean;
  setToken: (t: string | null) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);
